// Event type icon URLs organized by category
export const EVENT_ICONS = {
  // Pricing Events
  pricing: {
    discount_added: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097285/discount_added.png',
    discount_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097402/pricing_events/pricing_events/discount_changed.png',
    discount_removed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097403/pricing_events/pricing_events/discount_removed.png',
    price_decreased: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097404/pricing_events/pricing_events/price_decreased.png',
    price_hidden: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097405/pricing_events/pricing_events/price_hidden.png',
    price_increased: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097405/pricing_events/pricing_events/price_increased.png',
    price_revealed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097406/pricing_events/pricing_events/price_revealed.png',
    pricing_restructured: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097406/pricing_events/pricing_events/pricing_restructured.png',
  },

  // Packaging Events
  packaging: {
    addon_added: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097421/packaging_events/packaging_events/addon_added.png',
    addon_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097422/packaging_events/packaging_events/addon_changed.png',
    addon_removed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097422/packaging_events/packaging_events/addon_removed.png',
    capacity_decreased: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097424/packaging_events/packaging_events/capacity_decreased.png',
    capacity_increased: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097424/packaging_events/packaging_events/capacity_increased.png',
    freemium_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097425/packaging_events/packaging_events/freemium_changed.png',
    plan_added: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097426/packaging_events/packaging_events/plan_added.png',
    plan_removed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097426/packaging_events/packaging_events/plan_removed.png',
    plan_renamed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097427/packaging_events/packaging_events/plan_renamed.png',
    pricing_metric_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097428/packaging_events/packaging_events/pricing_metric_changed.png',
    threshold_added: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097429/packaging_events/packaging_events/threshold_added.png',
    threshold_removed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097429/packaging_events/packaging_events/threshold_removed.png',
    trial_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097439/packaging_events/packaging_events/trial_changed.png',
  },

  // Product Events
  product: {
    feature_added: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097439/product_events/product_events/feature_added.png',
    feature_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097440/product_events/product_events/feature_changed.png',
    feature_removed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1769097441/product_events/product_events/feature_removed.png',
    positioning_changed: 'https://res.cloudinary.com/dd6dkaan9/image/upload/v1771345881/product_events/product_events/positioning_changed.png',
  },
} as const;

// Helper function to get icon URL for a given event type
export const getEventIconUrl = (eventType: string): string | undefined => {
  // Try pricing events
  if (eventType in EVENT_ICONS.pricing) {
    return EVENT_ICONS.pricing[eventType as keyof typeof EVENT_ICONS.pricing];
  }

  // Try packaging events
  if (eventType in EVENT_ICONS.packaging) {
    return EVENT_ICONS.packaging[eventType as keyof typeof EVENT_ICONS.packaging];
  }

  // Try product events
  if (eventType in EVENT_ICONS.product) {
    return EVENT_ICONS.product[eventType as keyof typeof EVENT_ICONS.product];
  }

  return undefined;
};
